import { Injectable } from '@angular/core';
import { State, Action, Selector, StateContext } from '@ngxs/store';
import { IFetchOptions } from '../jsonApi/BaseCollectionService';
import { FetchOptionsActions } from './fetchOptions.actions';

export interface FetchOptionsStateModel extends IFetchOptions {
  total: number
}

export class FetchOptionsStateDefault implements IFetchOptions {
  pageNumber = 1;
  pageSize = 25;
  total = 0;
  fields: string[] = [];
}

@State<FetchOptionsStateModel>({
  name: 'fetchOptions',
  defaults: new FetchOptionsStateDefault()
})

@Injectable()
export class FetchOptionsState {
  @Selector()
  static getFields(state: FetchOptionsStateModel) {
    return state.fields;
  }

  @Selector()
  static getPageSize(state: FetchOptionsStateModel) {
    return state.pageSize;
  }

  @Selector()
  static getPageNumber(state: FetchOptionsStateModel) {
    return state.pageNumber;
  }

  @Selector()
  static getTotal(state: FetchOptionsStateModel) {
    return state.total;
  }

  @Selector()
  static getFilter(state: FetchOptionsStateModel) {
    return state.filter;
  }

  @Selector()
  static getFilters(state: FetchOptionsStateModel) {
    return state.filters;
  }

  @Selector()
  static getSortDirection(state: FetchOptionsStateModel) {
    return state.sortDirection;
  }

  @Selector()
  static getSortFieldName(state: FetchOptionsStateModel) {
    return state.sortFieldName;
  }

  @Action(FetchOptionsActions.UpdateFields)
  onUpdateFields(ctx: StateContext<FetchOptionsStateModel>, action: FetchOptionsActions.UpdateFields) {
    ctx.patchState({
      fields: action.fields
    });
  }

  @Action(FetchOptionsActions.UpdatePageNumber)
  onUpdatePageNumber(ctx: StateContext<FetchOptionsStateModel>, action: FetchOptionsActions.UpdatePageNumber) {
    ctx.patchState({
      pageNumber: action.pageNumber
    });
  }

  @Action(FetchOptionsActions.ResetPageNumber)
  onResetPageNumber(ctx: StateContext<FetchOptionsStateModel>) {
    ctx.patchState({
      pageNumber: new FetchOptionsStateDefault().pageNumber
    });
  }

  @Action(FetchOptionsActions.UpdatePageSize)
  onUpdatePageSize(ctx: StateContext<FetchOptionsStateModel>, action: FetchOptionsActions.UpdatePageSize) {
    ctx.patchState({
      pageSize: action.pageSize
    });
  }

  @Action(FetchOptionsActions.UpdateTotalItems)
  onUpdateTotal(ctx: StateContext<FetchOptionsStateModel>, action: FetchOptionsActions.UpdateTotalItems) {
    ctx.patchState({
      total: action.total
    });
  }

  @Action(FetchOptionsActions.UpdateFilter)
  onUpdateFilter(ctx: StateContext<FetchOptionsStateModel>, action: FetchOptionsActions.UpdateFilter) {
    ctx.patchState({
      filter: action.filter
    });
  }

  @Action(FetchOptionsActions.UpdateFilters)
  onUpdateFilters(ctx: StateContext<FetchOptionsStateModel>, action: FetchOptionsActions.UpdateFilters) {
    ctx.patchState({
      filters: action.filters
    });
  }

  @Action(FetchOptionsActions.UpdateSortFieldName)
  onUpdateSort(ctx: StateContext<FetchOptionsStateModel>, action: FetchOptionsActions.UpdateSortFieldName) {
    ctx.patchState({
      sortFieldName: action.sortFieldName
    });
  }

  @Action(FetchOptionsActions.UpdateSortDirection)
  onUpdateSortDirection(ctx: StateContext<FetchOptionsStateModel>, action: FetchOptionsActions.UpdateSortDirection) {
    ctx.patchState({
      sortDirection: action.sortDirection
    });
  }

  @Action(FetchOptionsActions.SetFromResult)
  onSetFromResult(ctx: StateContext<FetchOptionsStateModel>, { meta }: FetchOptionsActions.SetFromResult) {
    ctx.patchState({
      pageNumber: meta.page.currentPage,
      pageSize: meta.page.perPage,
      total: meta.page.total
    });
  }

  @Action(FetchOptionsActions.ToDefault)
  onToDefault(ctx: StateContext<FetchOptionsStateModel>) {
    ctx.patchState(new FetchOptionsStateDefault());
  }
}
